class Team {
    name = '';
    id = '';
    from;
    to;
    teamManagerId = '';
    teamManagerFirstName = '';
    teamManagerLastName = '';
    directorId = '';
    constructor(json) {
        if (json !== null) {
            try {
                this.id = json.id || '';
                this.name = json.name || '';
                this.from = this.convertToDate(json.from) || null;
                this.to = this.convertToDate(json.to) || null;
                this.teamManagerId = json.teamManagerId || '';
                this.teamManagerFirstName = json.teamManagerFirstName;
                this.teamManagerLastName = json.teamManagerLastName;
                this.directorId = json.directorId;
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/Team.ts -> constructor');
            }
        }
    }
    convertToDate(date) {
        if (date !== null) {
            return window.dateHandler.convertToUTCTime(date);
        }
        else {
            return null;
        }
    }
}
export default Team;
